<article class="lum-page lum-page__card lum-c-cost-layer">
  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">
      <a routerLink="/cost-layers">Cost Layers</a> /
      <ng-container *ngIf="viewMode === EResourceViewMode.CREATE">
        Create
      </ng-container>
      <ng-container *ngIf="viewMode === EResourceViewMode.READ">
        {{ id }}
      </ng-container>
      <ng-container *ngIf="viewMode === EResourceViewMode.UPDATE">
        <a [routerLink]="['/cost-layers', id]">{{ id }}</a> / Edit
      </ng-container>
    </h2>
    <div class="lum-page-header__actions">
      <ng-container *ngIf="isEditing; else whenViewing">
        <a
          class="lum-button lum-button--secondary"
          [routerLink]="['/cost-layers', id]"
        >
          Cancel
        </a>
        <button
          type="button"
          class="lum-button lum-button--secondary"
          (click)="handleClickRevert($event)"
          [disabled]="editHelper.form.pristine"
        >
          Clear Changes
        </button>
        <button
          type="button"
          class="lum-button lum-button--primary"
          (click)="handleClickSave($event)"
          [disabled]="editHelper.form.pristine || editHelper.form.invalid"
        >
          Save
        </button>
      </ng-container>
      <ng-template #whenViewing>
        <a
          *ngIf="'utah-UTAH-210-single_cost_layer_edit' | featureFlag"
          class="lum-button lum-button--secondary"
          [routerLink]="['/cost-layers', id, 'edit']"
        >
          Edit
        </a>
      </ng-template>
    </div>
  </header>

  <div class="lum-page-content">
    <router-outlet></router-outlet>
  </div>
</article>
